export * from './lib/shared-feature-logout.module';
export * from './lib/logout.component';
